/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './components/contact-duplicates-dialog/contact-duplicates-dialog.component';
export * from './components/contact-details-tab-container/contact-details-tab-container.component';
export * from './components/contact-details-common-tab/contact-details-common-tab.component';
export * from './components/contact-details-employee-tab/contact-details-employee-tab.component';
export * from './components/contact-details-employee-common-tab/contact-details-employee-common-tab.component';
export *
  from './components/contact-details-shared-custom-fields-tab/contact-details-shared-custom-fields-tab.component';
export * from './components/contact-details-creditor-tab/contact-details-creditor-tab.component';
export * from './components/contact-details-creditor-common-tab/contact-details-creditor-common-tab.component';
export *
  from './components/contact-details-creditor-common-tab/contact-details-creditor-destination/contact-details-creditor-destination.component';
export *
  from './components/contact-details-creditor-sub-contractor-tab/contact-details-creditor-sub-contractor-tab.component';
export * from './components/contact-details-customer-tab/contact-details-customer-tab.component';
export * from './components/contact-details-customer-common-tab/contact-details-customer-common-tab.component';
export * from './components/contact-details-debtor-tab/contact-details-debtor-tab.component';
export * from './components/contact-details-debtor-common-tab/contact-details-debtor-common-tab.component';
export * from './components/contact-details-shared-terms-tab/contact-details-shared-terms-payer-tab.component';
export * from './components/contact-details-shared-terms-tab/contact-details-shared-terms-payee-tab.component';
export *
  from './components/contact-details-shared-communication-list-tab/contact-details-shared-communication-list-tab.component';
export * from './components/contact-details-other-tab/contact-details-other-tab.component';
export * from './components/contact-details-city-county-tab/contact-details-city-county-tab.component';
export *
  from './components/contact-details-finance-company-common-tab/contact-details-finance-company-common-tab.component';
export * from './components/contact-details-finance-company-tab/contact-details-finance-company-tab.component';
export * from './components/contact-details-shared-portal-tab/contact-details-shared-portal-tab.component';
export *
  from './components/contact-details-customer-additional-details-tab/contact-details-customer-additional-details-tab.component';
export *
  from './components/contact-details-customer-additional-details-tab/customer-relative/contact-details-customer-relative.component';

export * from './services/contact-details-model.service';
export * from './resources/contact-details-business.service';
